import approval from "../assets/theme1/inset/approval.png";
import guide1 from "../assets/theme2/insets/guide1.png";
import guide2 from "../assets/theme2/insets/guide2.png";
import guide3 from "../assets/theme2/insets/guide3.png";
import guide4 from "../assets/theme2/insets/guide4.png";
import noSearch from "../assets/theme2/insets/no-search.png"; // import noReport from "../assets/theme2/insets/no-report.png";

import noMessage from "../assets/theme2/insets/no-message.png";
import noNetwork from "../assets/theme2/insets/no-network.png";
import noSafe from "../assets/theme2/insets/no-safe.png";
import noSysMessage from "../assets/theme2/insets/no-sys-message.png";
import passed from "../assets/theme2/insets/passed.png";
import submitted from "../assets/theme2/insets/submited.png";
import remind from "../assets/theme2/insets/remind.png";
import welcome from "../assets/theme2/insets/welcome.png";
import male from "../assets/theme2/avatar/man.png";
import female from "../assets/theme2/avatar/woman.png";
import nameAvatar1 from "../assets/theme2/avatar/name1@2x.png";
import nameAvatar2 from "../assets/theme2/avatar/name2@2x.png";
import nameAvatar3 from "../assets/theme2/avatar/name3@2x.png";
import nameAvatar4 from "../assets/theme2/avatar/name4@2x.png";
var theme2ImageData = {
  name: 'images',
  global: true,
  data: [
  // 配套主题的插图
  {
    approval: approval,
    // 审核中
    guide1: guide1,
    // 引导1
    guide2: guide2,
    // 引导2
    guide3: guide3,
    // 引导3
    guide4: guide4,
    // 引导4
    noSearch: noSearch,
    // 无内容1
    noReport: '',
    // 无内容2
    noMessage: noMessage,
    // 无消息
    noNetwork: noNetwork,
    // 无网络
    noSafe: noSafe,
    // 无风险日志
    noSysMessage: noSysMessage,
    // 没有系统消息
    passed: passed,
    // 已通过
    submitted: submitted,
    // 已提交
    remind: remind,
    // 提示消息（尊敬的用户您好......）
    welcome: welcome,
    // 欢迎插画
    male: male,
    // 默认男性头像
    female: female,
    // 默认女性头像
    nameAvatar1: nameAvatar1,
    // 名字头像，下同
    nameAvatar2: nameAvatar2,
    nameAvatar3: nameAvatar3,
    nameAvatar4: nameAvatar4
  }]
};
export { theme2ImageData };